let supportedLanguages = null;

export const setSupportedLanguages = (languages) => {
  if (Array.isArray(languages) && languages.length > 0) {
    supportedLanguages = languages;
  }
};

export const getSupportedLanguages = () => supportedLanguages;
